import styled, { keyframes } from 'styled-components';

const sweep = keyframes`
  from { transform: translateX(-100%); }
  to { transform: translateX(250%); }
`;

const drift = keyframes`
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  33% { transform: translate(6px, -8px) rotate(2deg); }
  66% { transform: translate(-5px, 4px) rotate(-1.5deg); }
`;

export const BuildingRoot = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  text-align: center;
`;

export const OrbHome = styled.div`
  margin-bottom: 8px;
  animation: ${drift} 7s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.onSurface};
`;

export const Description = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const ProgressTrack = styled.div`
  position: relative;
  overflow: hidden;
  width: min(240px, 60%);
  height: 4px;
  margin-top: 12px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.surfaceContainerHighest};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    width: 40%;
    border-radius: inherit;
    background: ${({ theme }) => theme.colors.primary};
    animation: ${sweep} 1.4s ease-in-out infinite;
  }

  @media (prefers-reduced-motion: reduce) {
    &::after {
      animation: none;
      width: 100%;
      opacity: 0.4;
    }
  }
`;

export const Steps = styled.div`
  width: min(320px, 100%);
  margin-top: 12px;
  text-align: start;
`;
